import React from 'react';
import { TabPanel, TabPanels } from '@chaser/components';
import PageContainer from '../../components/PageContainer/index';
import Configure from './components/Configure';
import Upload from './components/Upload';
import NavigationTabs from '../../components/NavigationTabs';
import useOrganisationInfo from '../../hooks/useOrganisationInfo';

const Import = () => {
  const { isManualCSV } = useOrganisationInfo();

  return (
    <PageContainer>
      <NavigationTabs
        basePath="/import"
        tabs={[
          { path: 'configure', title: 'Configure' },
          isManualCSV ? { path: 'upload', title: 'Upload' } : null,
        ].filter(Boolean)}
        menuOnMobile
      >
        <TabPanels>
          <TabPanel>
            <Configure />
          </TabPanel>
          {isManualCSV ? (
            <TabPanel>
              <Upload />
            </TabPanel>
          ) : (
            <></>
          )}
        </TabPanels>
      </NavigationTabs>
    </PageContainer>
  );
};

export default Import;
